/* eslint-disable @typescript-eslint/no-explicit-any */

import * as types from "../actionTypes/dashboardActionTypes";
import { SET_DARK_THEME } from "../actionTypes/dashboardActionTypes";

export const getSearchLocAction = {
  STARTED: (args: any) => ({
    type: types.GET_SEARCH_LOC.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_SEARCH_LOC.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_SEARCH_LOC.REJECTED }),
};

export const getCurrencyListAction = {
  STARTED: () => ({ type: types.GET_CURRENCY_LIST.STARTED }),
  FULLFILLED: (results: any) => ({
    type: types.GET_CURRENCY_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_CURRENCY_LIST.REJECTED }),
};

export const getNationalityListAction = {
  STARTED: () => ({ type: types.GET_NATIONALITY_LIST.STARTED }),
  FULLFILLED: (results: any) => ({
    type: types.GET_NATIONALITY_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_NATIONALITY_LIST.REJECTED }),
};

export const getCityListAction = {
  STARTED: (args: any) => ({
    type: types.GET_CITY_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_CITY_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_CITY_LIST.REJECTED }),
};

// TW
export const getAgentListAction = {
  STARTED: (args: any) => ({
    type: types.GET_AGENTS_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AGENTS_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_AGENTS_LIST.REJECTED }),
};

// TW
export const getAllActiveAgentsDetailsListAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVE_AGENTS_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVE_AGENTS_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVE_AGENTS_DETAILS.REJECTED }),
};

// TW
export const getAgentUsersListAction = {
  STARTED: (args: any) => ({
    type: types.GET_AGENTS_USERS_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AGENTS_USERS_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_AGENTS_USERS_LIST.REJECTED }),
};

// TW
export const getCurrenciesByAgentIdAction = {
  STARTED: (args: any) => ({
    type: types.GET_CURRENCIES_BY_AGENTID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_CURRENCIES_BY_AGENTID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_CURRENCIES_BY_AGENTID.REJECTED }),
};

export const getAgentByIdAction = {
  STARTED: (args: any) => ({
    type: types.GET_AGENT_BY_ID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AGENT_BY_ID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_AGENT_BY_ID.REJECTED }),
};

export const getCurrencyConversionRatesAction = {
  STARTED: (args: any) => ({
    type: types.GET_CURRENCY_CONVERSION_RATES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_CURRENCY_CONVERSION_RATES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_CURRENCY_CONVERSION_RATES.REJECTED }),
};

export const getAgentCreditLimitAction = {
  STARTED: (args: any) => ({
    type: types.GET_AGENT_CREDIT_LIMIT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AGENT_CREDIT_LIMIT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_AGENT_CREDIT_LIMIT.REJECTED }),
};

export const voucherViewDetailsAction = {
  STARTED: (args: any) => ({
    type: types.VOUCHER_VIEW_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VOUCHER_VIEW_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VOUCHER_VIEW_DETAILS.REJECTED }),
};

export const voucherViewEurailDetailsAction = {
  STARTED: (args: any) => ({
    type: types.VOUCHER_VIEW_EURAIL_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VOUCHER_VIEW_EURAIL_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VOUCHER_VIEW_EURAIL_DETAILS.REJECTED }),
};

export const voucherViewTransferDetailsAction = {
  STARTED: (args: any) => ({
    type: types.VOUCHER_VIEW_TRANSFER_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VOUCHER_VIEW_TRANSFER_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VOUCHER_VIEW_TRANSFER_DETAILS.REJECTED }),
};

export const voucherViewActivityDetailsAction = {
  STARTED: (args: any) => ({
    type: types.VOUCHER_VIEW_ACTIVITY_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VOUCHER_VIEW_ACTIVITY_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VOUCHER_VIEW_ACTIVITY_DETAILS.REJECTED }),
};

export const biDfromTempIdAction = {
  STARTED: (args: any) => ({
    type: types.BID_FROM_TEMP_ID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.BID_FROM_TEMP_ID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.BID_FROM_TEMP_ID.REJECTED }),
};

export const getMailTemplateAction = {
  STARTED: (args: any) => ({
    type: types.GET_MAIL_TEMPLATE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_MAIL_TEMPLATE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_MAIL_TEMPLATE.REJECTED }),
};

export const bookingDraftByTWBidAction = {
  STARTED: (args: any) => ({
    type: types.GET_BOOKINGDRAFT_BY_TWBID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_BOOKINGDRAFT_BY_TWBID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_BOOKINGDRAFT_BY_TWBID.REJECTED }),
};

export const thresholdLimitAdminAction = {
  STARTED: (args: any) => ({
    type: types.GET_GET_THRESHOLDLIMIT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_GET_THRESHOLDLIMIT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_GET_THRESHOLDLIMIT.REJECTED }),
};

export const addMailLogAction = {
  STARTED: (args: any) => ({
    type: types.GET_ADD_MAIL_LOG.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ADD_MAIL_LOG.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ADD_MAIL_LOG.REJECTED }),
};

export const configValueAction = {
  STARTED: (args: any) => ({
    type: types.CONFIG_VALUE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.CONFIG_VALUE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.CONFIG_VALUE.REJECTED }),
};

export const paymentGatewayTransactionsAction = {
  STARTED: (args: any) => ({
    type: types.PAYMENT_GATEWAY_TRANSACTIONS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.PAYMENT_GATEWAY_TRANSACTIONS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.PAYMENT_GATEWAY_TRANSACTIONS.REJECTED }),
};

export const addUpdateBookingUploadAction = {
  STARTED: (args: any) => ({
    type: types.GET_ADD_UPDATE_BOOKING_UPLOAD.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ADD_UPDATE_BOOKING_UPLOAD.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ADD_UPDATE_BOOKING_UPLOAD.REJECTED }),
};

export const addUpdateBookingDraftAction = {
  STARTED: (args: any) => ({
    type: types.GET_ADD_UPDATE_BOOKING_DRAFT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ADD_UPDATE_BOOKING_DRAFT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ADD_UPDATE_BOOKING_DRAFT.REJECTED }),
};

export const bookingDetailsBasedOnItineraryId = {
  STARTED: (args: any) => ({
    type: types.BOOKINGDETAILS_BY_ITERNARYID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.BOOKINGDETAILS_BY_ITERNARYID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.BOOKINGDETAILS_BY_ITERNARYID.REJECTED }),
};

export const previewUrlAction = {
  STARTED: (payload: any) => ({
    type: types.PREVIEW_URL.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.PREVIEW_URL.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.PREVIEW_URL.REJECTED,
    payload: error,
  }),
};

export const addAgentQuoteAction = {
  STARTED: (args: any) => ({
    type: types.GET_ADD_AGENTQUOTE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ADD_AGENTQUOTE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ADD_AGENTQUOTE.REJECTED }),
};

export const validatePaymentLinkAction = {
  STARTED: (args: any) => ({
    type: types.VALIDATE_PAYMENT_LINK.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VALIDATE_PAYMENT_LINK.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VALIDATE_PAYMENT_LINK.REJECTED }),
};

export const postPaymentGatewayAction = {
  STARTED: (args: any) => ({
    type: types.POST_PAYMENT_GATEWAY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.POST_PAYMENT_GATEWAY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.POST_PAYMENT_GATEWAY.REJECTED }),
};

export const validatePGCurrencyAction = {
  STARTED: (args: any) => ({
    type: types.VALIDATE_PG_CURRENCY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VALIDATE_PG_CURRENCY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VALIDATE_PG_CURRENCY.REJECTED }),
};

export const getHotelSearchAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_SEARCH.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_SEARCH.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTEL_SEARCH.REJECTED }),
};

export const getProductSearchTimeExpireAction = {
  FULLFILLED: (results: any) => ({
    type: types.SET_PRODUCT_SEARCH_TIME_EXPIRE.FULLFILLED,
    payload: results,
  }),
};

export const getHotelsListAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTELS_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTELS_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTELS_LIST.REJECTED }),
};

export const getSearchAddressAction = {
  STARTED: (args: any) => ({
    type: types.GET_SEARCH_ADDRESSES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_SEARCH_ADDRESSES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_SEARCH_ADDRESSES.REJECTED }),
};

export const getSearchExtraDetailsAction = {
  STARTED: (args: any) => ({
    type: types.GET_SEARCH_EXTRA_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_SEARCH_EXTRA_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_SEARCH_EXTRA_DETAILS.REJECTED }),
};

export const getHotellevelfilterAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_LEVEL_FILTER.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_LEVEL_FILTER.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTEL_LEVEL_FILTER.REJECTED }),
};

export const getHotelInfoAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_INFO.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_INFO.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTEL_INFO.REJECTED }),
};

export const getHotelRatesAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_RATES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_RATES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTEL_RATES.REJECTED }),
};

export const getSimilarHotelsAction = {
  STARTED: (args: any) => ({
    type: types.GET_SIMILAR_HOTELS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_SIMILAR_HOTELS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_SIMILAR_HOTELS.REJECTED }),
  RESET: () => ({ type: types.GET_SIMILAR_HOTELS.RESET }),
};

export const resetHotelDetailsAction = {
  STARTED: () => ({ type: types.RESET_HOTEL_DETAILS }),
};

export const getHotelRatesMoreAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_RATES_MORE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_RATES_MORE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTEL_RATES_MORE.REJECTED }),
};

export const getRoomOptionsRatesAction = {
  STARTED: (args: any) => ({
    type: types.GET_ROOM_OPTIONS_RATES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ROOM_OPTIONS_RATES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ROOM_OPTIONS_RATES.REJECTED }),
};

export const getRoomOptionsRatesMoreAction = {
  STARTED: (args: any) => ({
    type: types.GET_ROOM_OPTIONS_RATES_MORE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ROOM_OPTIONS_RATES_MORE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ROOM_OPTIONS_RATES_MORE.REJECTED }),
};

export const getHotelMultiRoomMeanRateAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_MULTIROOM_MEAN_RATE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_MULTIROOM_MEAN_RATE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_HOTEL_MULTIROOM_MEAN_RATE.REJECTED }),
};

export const getAirportsAction = {
  STARTED: (args: any) => ({ type: types.GET_AIRPORTS.STARTED, payload: args }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AIRPORTS.FULLFILLED,
    payload: results,
  }),
  RESET: () => ({
    type: types.GET_AIRPORTS.RESET,
    payload: {},
  }),
  REJECTED: () => ({ type: types.GET_AIRPORTS.REJECTED }),
};

export const getDropAirportsAction = {
  STARTED: (args: any) => ({
    type: types.GET_DROP_AIRPORTS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DROP_AIRPORTS.FULLFILLED,
    payload: results,
  }),
  RESET: () => ({
    type: types.GET_DROP_AIRPORTS.RESET,
    payload: {},
  }),
  REJECTED: () => ({ type: types.GET_DROP_AIRPORTS.REJECTED }),
};

export const getAirlinesAction = {
  STARTED: (args: any) => ({ type: types.GET_AIRLINES.STARTED, payload: args }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AIRLINES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_AIRLINES.REJECTED }),
};

export const getAccommodationsAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACCOMMODATION.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACCOMMODATION.FULLFILLED,
    payload: results,
  }),
  RESET: () => ({
    type: types.GET_ACCOMMODATION.RESET,
    payload: {},
  }),
  REJECTED: () => ({ type: types.GET_ACCOMMODATION.REJECTED }),
};

export const getDropAccommodationsAction = {
  STARTED: (args: any) => ({
    type: types.GET_DROP_ACCOMMODATION.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DROP_ACCOMMODATION.FULLFILLED,
    payload: results,
  }),
  RESET: () => ({
    type: types.GET_DROP_ACCOMMODATION.RESET,
    payload: {},
  }),
  REJECTED: () => ({ type: types.GET_DROP_ACCOMMODATION.REJECTED }),
};

export const getDestinationAction = {
  STARTED: (args: any) => ({
    type: types.GET_DESTINATION.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DESTINATION.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DESTINATION.REJECTED }),
};

export const getDestinationToAction = {
  STARTED: (args: any) => ({
    type: types.GET_DESTINATIONTO.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DESTINATIONTO.FULLFILLED,
    payload: results,
  }),
  RESET: () => ({
    type: types.GET_DESTINATIONTO.RESET,
    payload: {},
  }),
  REJECTED: () => ({ type: types.GET_DESTINATIONTO.REJECTED }),
};

export const getDestinationActivityAction = {
  STARTED: (args: any) => ({
    type: types.GET_DESTINATION_ACTIVITY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DESTINATION_ACTIVITY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DESTINATION_ACTIVITY.REJECTED }),
};

export const addUserSearchHistoryAction = {
  STARTED: (args: any) => ({
    type: types.GET_ADD_USER_SEARCH_HISTORY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ADD_USER_SEARCH_HISTORY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ADD_USER_SEARCH_HISTORY.REJECTED }),
};

export const getUserSearchHistoryAction = {
  STARTED: (args: any) => ({
    type: types.GET_GET_USER_SEARCH_HISTORY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_GET_USER_SEARCH_HISTORY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_GET_USER_SEARCH_HISTORY.REJECTED }),
};

export const getCancellationPolicyAction = {
  STARTED: (args: any) => ({
    type: types.GET_CALL_CANCELLATION_POLICY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_CALL_CANCELLATION_POLICY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_CALL_CANCELLATION_POLICY.REJECTED }),
};

export const getGetAllCurrentSuppliersAction = {
  STARTED: (args: any) => ({
    type: types.GET_ALL_CURRENT_SUPPLIERS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ALL_CURRENT_SUPPLIERS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ALL_CURRENT_SUPPLIERS.REJECTED }),
};

export const getValidateDuplicateBookingAction = {
  STARTED: (args: any) => ({
    type: types.VALIDATE_DUPLICATE_BOOKING.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VALIDATE_DUPLICATE_BOOKING.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.VALIDATE_DUPLICATE_BOOKING.REJECTED }),
};

export const agentInvoiceAction = {
  STARTED: (payload: any) => ({
    type: types.AGENT_INVOICE_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.AGENT_INVOICE_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.AGENT_INVOICE_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};

export const agentInfoFinalizeTransferAction = {
  STARTED: (args: any) => ({
    type: types.AGENT_INFO_FINALIZE_TRANSFER.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.AGENT_INFO_FINALIZE_TRANSFER.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.AGENT_INFO_FINALIZE_TRANSFER.REJECTED }),
};

export const priceCalculateOcPcAction = {
  STARTED: (args: any) => ({
    type: types.PRICE_CALCULATE_OC_PC.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.PRICE_CALCULATE_OC_PC.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.PRICE_CALCULATE_OC_PC.REJECTED }),
};

export const postPriceCalculateAction = {
  STARTED: (payload: any) => ({
    type: types.POST_PRICE_CALCULATE.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.POST_PRICE_CALCULATE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.POST_PRICE_CALCULATE.REJECTED,
  }),
};

export const getAgentsByCurrencyAction = {
  STARTED: (payload: any) => ({
    type: types.AGENTS_BY_CURRENCY.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.AGENTS_BY_CURRENCY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.AGENTS_BY_CURRENCY.REJECTED }),
};

export const agentsByCurrencyandInvoiceEntityAction = {
  STARTED: (payload: any) => ({
    type: types.AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE.REJECTED,
  }),
};

export const queryBookingsListAction = {
  STARTED: (payload: any) => ({
    type: types.BOOKINGS_LIST.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.BOOKINGS_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.BOOKINGS_LIST.REJECTED,
    payload: error,
  }),
};

export const addTransferToAgentAction = {
  STARTED: (payload: any) => ({
    type: types.ADD_TRANSFER_TO_AGENT.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_TRANSFER_TO_AGENT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.ADD_TRANSFER_TO_AGENT.REJECTED,
  }),
};

export const queryAddFinalizeBookingsAction = {
  STARTED: (payload: any) => ({
    type: types.ADD_FINALIZE_BOOKINGS.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_FINALIZE_BOOKINGS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.ADD_FINALIZE_BOOKINGS.REJECTED }),
};

export const getGetActivitiesCurrentSuppliersAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITIES_CURRENT_SUPPLIERS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITIES_CURRENT_SUPPLIERS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITIES_CURRENT_SUPPLIERS.REJECTED }),
};

// these are used to know whether to call particular apis or not
export const setCallHotelListApi = (payload: boolean) => ({
  type: types.SET_CALL_HOTEL_LIST_API,
  payload,
});

export const setCallAddressesApi = (payload: boolean) => ({
  type: types.SET_CALL_ADDRESSES_API,
  payload,
});

export const setCallExtraDetailsApi = (payload: boolean) => ({
  type: types.SET_CALL_EXTRA_DETAILS_API,
  payload,
});

export const setSideNavBarFocus = (payload: string) => ({
  type: types.SET_SIDE_NAV_BAR_FOCUS,
  payload,
});

// Booking Process Actions Starts here
export const getBooknowIdAction = {
  STARTED: (args: any) => ({
    type: types.GET_BOOKNOW_ID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_BOOKNOW_ID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_BOOKNOW_ID.REJECTED }),
};

export const getRecheckPriceAction = {
  STARTED: (args: any) => ({
    type: types.GET_RECHECK_PRICE.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_RECHECK_PRICE.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_RECHECK_PRICE.REJECTED }),
};

// ------------------------------------> THIS IS DEPRICATED API. AND SHOULD NOT USE
// export const getBookingDetailsAction = {
//   STARTED: (args: any) => ({
//     type: types.GET_BOOKING_DETAILS.STARTED,
//     payload: args,
//   }),
//   FULLFILLED: (results: any) => ({
//     type: types.GET_BOOKING_DETAILS.FULLFILLED,
//     payload: results,
//   }),
//   REJECTED: () => ({ type: types.GET_BOOKING_DETAILS.REJECTED }),
// };
// ------------------------------------> THIS IS DEPRICATED API. AND SHOULD NOT USE

export const getBookingDetailsByBidAction = {
  STARTED: (args: any) => ({
    type: types.GET_BOOKING_DETAILS_BYBID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_BOOKING_DETAILS_BYBID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_BOOKING_DETAILS_BYBID.REJECTED }),
};

export const getHotelCheckoutDetailsAction = {
  STARTED: (args: any) => ({
    type: types.GET_HOTEL_CHECKOUT_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_CHECKOUT_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: (results: any) => ({
    type: types.GET_HOTEL_CHECKOUT_DETAILS.REJECTED,
    payload: results,
  }),
};

export const addPGTransactionAction = {
  STARTED: (args: any) => ({
    type: types.ADD_PG_TRANSACTION_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_PG_TRANSACTION_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.ADD_PG_TRANSACTION_DETAILS.REJECTED,
  }),
};

export const generateHash512Action = {
  STARTED: (args: any) => ({
    type: types.GENERATE_HASH512_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GENERATE_HASH512_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.GENERATE_HASH512_DETAILS.REJECTED,
  }),
};

export const getDMCListAction = {
  STARTED: (args: any) => ({
    type: types.GET_DMC_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DMC_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DMC_LIST.REJECTED }),
};

export const getDMCCitiesAction = {
  STARTED: (args: any) => ({
    type: types.GET_DMC_CITIES_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DMC_CITIES_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DMC_CITIES_LIST.REJECTED }),
};

export const getDMCTourTypesAction = {
  STARTED: (args: any) => ({
    type: types.GET_DMC_TOURTYPES_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DMC_TOURTYPES_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DMC_TOURTYPES_LIST.REJECTED }),
};

export const getDMCPackagesAction = {
  STARTED: (args: any) => ({
    type: types.GET_DMC_PACKAGES_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DMC_PACKAGES_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DMC_PACKAGES_LIST.REJECTED }),
};

export const getDMCPackDetailsAction = {
  STARTED: (args: any) => ({
    type: types.GET_DMC_PACKAGES_DETAILS_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_DMC_PACKAGES_DETAILS_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_DMC_PACKAGES_DETAILS_LIST.REJECTED }),
};

export const validatePANAction = {
  STARTED: (args: any) => ({
    type: types.VALIDATE_PAN_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.VALIDATE_PAN_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.VALIDATE_PAN_DETAILS.REJECTED,
  }),
};

export const activityCancellationPolicyAction = {
  STARTED: (args: any) => ({
    type: types.ACTIVITY_CANCELLATION_POLICY_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ACTIVITY_CANCELLATION_POLICY_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.ACTIVITY_CANCELLATION_POLICY_DETAILS.REJECTED,
  }),
};

export const transferCancellationPolicyAction = {
  STARTED: (args: any) => ({
    type: types.TRANSFER_CANCELLATION_POLICY_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.TRANSFER_CANCELLATION_POLICY_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.TRANSFER_CANCELLATION_POLICY_DETAILS.REJECTED,
  }),
};

export const updateValidationStatusAction = {
  STARTED: (args: any) => ({
    type: types.UPDATE_VALIDATION_STATUS_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.UPDATE_VALIDATION_STATUS_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.UPDATE_VALIDATION_STATUS_DETAILS.REJECTED,
  }),
};

export const abandonReasonsAction = {
  STARTED: (args: any) => ({
    type: types.ABANDON_REASONS_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ABANDON_REASONS_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.ABANDON_REASONS_DETAILS.REJECTED,
  }),
};

export const bookableThresholdLimitAction = {
  STARTED: (args: any) => ({
    type: types.BOOKABLE_THRESHOLD_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.BOOKABLE_THRESHOLD_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.BOOKABLE_THRESHOLD_DETAILS.REJECTED,
  }),
};

export const bookableCLAction = {
  STARTED: (args: any) => ({
    type: types.BOOKABLE_CL_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.BOOKABLE_CL_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.BOOKABLE_CL_DETAILS.REJECTED,
  }),
};

export const bookableWBAction = {
  STARTED: (args: any) => ({
    type: types.BOOKABLE_WB_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.BOOKABLE_WB_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.BOOKABLE_WB_DETAILS.REJECTED,
  }),
};

export const getAgentProfileByAgentIdAction = {
  STARTED: (args: any) => ({
    type: types.GET_AGENT_PROFILE_BY_AGENTID.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_AGENT_PROFILE_BY_AGENTID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_AGENT_PROFILE_BY_AGENTID.REJECTED }),
};

export const getAgentAllWidgetsDataAction = {
  STARTED: (args: any) => ({
    type: types.AGENT_ALL_WIDGETS_DATA.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.AGENT_ALL_WIDGETS_DATA.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.AGENT_ALL_WIDGETS_DATA.REJECTED }),
};

export const generateFeaturedHotelsAction = {
  STARTED: (args: any) => ({
    type: types.GENERATE_FEATURED_HOTELS_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GENERATE_FEATURED_HOTELS_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.GENERATE_FEATURED_HOTELS_DETAILS.REJECTED,
  }),
};

// export const setSEARCHKEY = (payload: string) => ({
//   type: types.SEARCHKEY,
//   payload
// });

// For Setting the Dark Theme
export const applyDarkTheme = (value: any) => {
  return {
    type: SET_DARK_THEME,
    payload: value,
  };
};

export const setZohoTicketDependencyMappingAction = {
  STARTED: () => ({
    type: types.SET_ZOHO_TICKET_DEPENDENCY_MAPPING.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_ZOHO_TICKET_DEPENDENCY_MAPPING.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_ZOHO_TICKET_DEPENDENCY_MAPPING.REJECTED,
    payload: error,
  }),
};

export const setZohoLayoutRulesAction = {
  STARTED: () => ({
    type: types.SET_ZOHO_LAYOUT_RULES.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_ZOHO_LAYOUT_RULES.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_ZOHO_LAYOUT_RULES.REJECTED,
    payload: error,
  }),
};

export const setZohoTicketCreationAction = {
  STARTED: (payload: any) => ({
    type: types.SET_ZOHO_TICKET_CREATION.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_ZOHO_TICKET_CREATION.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.SET_ZOHO_TICKET_CREATION.REJECTED,
  }),
};

export const updatePGInvoiceNumberAction = {
  STARTED: (payload: any) => ({
    type: types.UPDATE_PG_INVOICE_NUMBER.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.UPDATE_PG_INVOICE_NUMBER.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.UPDATE_PG_INVOICE_NUMBER.REJECTED,
  }),
};

// export const addBookingMailDataAction = {
//   STARTED: (payload: any) => ({
//     type: types.ADD_BOOKING_MAIL_DATA.STARTED,
//     payload: payload,
//   }),
//   FULLFILLED: (results: any) => ({
//     type: types.ADD_BOOKING_MAIL_DATA.FULLFILLED,
//     payload: results,
//   }),
//   REJECTED: () => ({
//     type: types.ADD_BOOKING_MAIL_DATA.REJECTED,
//   }),
// };

export const generateLoginUrlAction = {
  STARTED: (payload: any) => ({
    type: types.GENERATE_LOGINURL_DETAILS.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GENERATE_LOGINURL_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.GENERATE_LOGINURL_DETAILS.REJECTED,
  }),
};

export const checkPanExistForAgentAction = {
  STARTED: (payload: any) => ({
    type: types.CHECK_PAN_EXISTS_FOR_AGENT_DATA.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.CHECK_PAN_EXISTS_FOR_AGENT_DATA.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.CHECK_PAN_EXISTS_FOR_AGENT_DATA.REJECTED,
  }),
};

export const queryBillingListAction = {
  STARTED: (payload: any) => ({
    type: types.GRN_INVOICES_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GRN_INVOICES_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GRN_INVOICES_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};

export const queryProformaAction = {
  STARTED: (payload: any) => ({
    type: types.GRN_PROFORMAS_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GRN_PROFORMAS_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GRN_PROFORMAS_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};

export const queryItineraryIdByTempIdAction = {
  STARTED: (payload: any) => ({
    type: types.ITINERARY_ID_BY_TEMPID.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ITINERARY_ID_BY_TEMPID.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.ITINERARY_ID_BY_TEMPID.REJECTED,
    payload: error,
  }),
};

export const addDuplicateBookingMailDataAction = {
  STARTED: (payload: any) => ({
    type: types.ADD_DUPLICATE_BOOKING_MAIL_DATA.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_DUPLICATE_BOOKING_MAIL_DATA.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.ADD_DUPLICATE_BOOKING_MAIL_DATA.REJECTED,
    payload: error,
  }),
};

export const finalizeBookingsTransferAdminAction = {
  STARTED: (payload: any) => ({
    type: types.FINALIZE_BOOKINGS_TRANSFER_ADMIN.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.FINALIZE_BOOKINGS_TRANSFER_ADMIN.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.FINALIZE_BOOKINGS_TRANSFER_ADMIN.REJECTED }),
};

export const finalizedBookingsTransferAgentAction = {
  STARTED: (payload: any) => ({
    type: types.FINALIZED_BOOKINGS_TRANSFER_AGENT.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.FINALIZED_BOOKINGS_TRANSFER_AGENT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.FINALIZED_BOOKINGS_TRANSFER_AGENT.REJECTED }),
};

export const addTransferToAgentTransferAction = {
  STARTED: (payload: any) => ({
    type: types.ADD_TRANSFER_TO_AGENT_TRANSFER.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ADD_TRANSFER_TO_AGENT_TRANSFER.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.ADD_TRANSFER_TO_AGENT_TRANSFER.REJECTED,
  }),
};

export const accessNotificationsPermissionsAction = {
  STARTED: (args: any) => ({
    type: types?.ACCESS_NOTIFICATIONS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types?.ACCESS_NOTIFICATIONS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types?.ACCESS_NOTIFICATIONS.REJECTED,
  }),
};

/*Invoice actions */
export const getHotelInvoiceAction = {
  STARTED: (payload: any) => ({
    type: types.GET_HOTEL_INVOICE_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_HOTEL_INVOICE_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GET_HOTEL_INVOICE_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};
export const getEurailInvoiceAction = {
  STARTED: (payload: any) => ({
    type: types.GET_EURAIL_INVOICE_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_EURAIL_INVOICE_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GET_EURAIL_INVOICE_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};
export const getActivityInvoiceAction = {
  STARTED: (payload: any) => ({
    type: types.GET_ACTIVITY_INVOICE_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITY_INVOICE_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GET_ACTIVITY_INVOICE_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};
export const getTransfersInvoiceAction = {
  STARTED: (payload: any) => ({
    type: types.GET_TRANSFERS_INVOICE_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_TRANSFERS_INVOICE_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GET_TRANSFERS_INVOICE_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};
export const requestFailureReasonStatusAction = {
  STARTED: (payload: any) => ({
    type: types.REQUEST_FAILURE_REASON_STATUS.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.REQUEST_FAILURE_REASON_STATUS.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.REQUEST_FAILURE_REASON_STATUS.REJECTED,
    payload: error,
  }),
};
export const sendVoucherMailAction = {
  STARTED: (payload: any) => ({
    type: types.SEND_VOUCHER_MAIL_ACTION_TYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SEND_VOUCHER_MAIL_ACTION_TYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.SEND_VOUCHER_MAIL_ACTION_TYPE.REJECTED,
    payload: error,
  }),
};
export const generateInvoicePdfAction = {
  STARTED: (payload: any) => ({
    type: types.GENERATE_INVOICE_PDF_ACTIONTYPE.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GENERATE_INVOICE_PDF_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.GENERATE_INVOICE_PDF_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};